export default __webpack_public_path__ + "static/media/visa.a22a43fd.jpg";